import { NavLink } from "react-router-dom";

const Unauthorized = () => {
  return (
    <>
      <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
        <h1 style={{ color: "red",marginTop:"10vw" }}>Giriş alınmadı</h1>
        <NavLink to="/login" style={{color:"#ffffff",fontSize:"2vw",backgroundColor:"#ff6010",borderRadius:"1vw",padding:"1vw"}}>Yeniden cehd edin</NavLink>
      </div>
    </>
  );
};



export default Unauthorized;